'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumber;
/**
 * Check if a value is a number
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isNumber(value) {
  return typeof value === 'number';
}
module.exports = exports['default'];
//# sourceMappingURL=is-number.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-input-range/lib/js/utils/is-number.js
// module id = 813
// module chunks = 95715928098905 168707334958949